import type { FC } from "react";

import STYLES from "@vita-learning/styles";

import styles from "./styles.module.scss";

interface SpinnerProps {
	readonly color?: "#FFF" | typeof STYLES.colors.vitas.primary;
}

export const Spinner: FC<SpinnerProps> = ({
	color = STYLES.colors.vitas.primary,
}) => (
	<div
		className={styles.loader}
		style={{
			borderTopColor: color,
			borderRightColor: color,
			borderBottomColor: color,
			borderLeftColor:
				color === "#FFF" ? STYLES.colors.vitas.secondary : "#FFF",
		}}
	>
		Loading...
	</div>
);
